'use strict';
import { Injectable} from 'ng-metadata/core';
const flattenDeep  = require('lodash/flattenDeep');
@Injectable()

export class ArrayUtils {

    constructor(){}

	range(n) {
         // Array.range(5) --> [0,1,2,3,4]
        return Array.apply(null, new Array(n)).map((x, i)=> {return i;});
    }

    chunk(array, n) {
        // ACTUAL CODE FOR CHUNKING ARRAY:
        return this.range(Math.ceil(array.length / n)).map(function(x, i) {
            return array.slice(i * n, i * n + n);
        }.bind(this));
    }

    //[1, [2, 3, [4]]] --> [1, 2, 3, 4]
    flattenDeep(array) {
    	return flattenDeep(array);
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/arrayUtils.service.ts